import React, { Suspense, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { showLeftSideBar } from '../config';
import { LayoutTypes } from '../constants';
import { changeBodyAttribute } from '../utils';

// code splitting and lazy loading
// https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52
const AdminTopbar = React.lazy(() => import('./AdminTopbar'));
const AdminLeftSidebar = React.lazy(() => import('./AdminLeftSidebar'));
const Footer = React.lazy(() => import('./Footer'));

const loading = () => <div className=""></div>;

interface AdminLayoutProps {
    children?: any;
}

const AdminLayout = ({ children }: AdminLayoutProps) => {

    const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false);

    /*
    layout defaults
    */
    useEffect(() => {
        changeBodyAttribute('data-layout-mode', LayoutTypes.LAYOUT_VERTICAL);
    }, []);

    /**
     * Open the menu when having mobile screen
     */
    const openMenu = () => {
        setIsMenuOpened((prevState) => !prevState);

        if (document.body) {
            if (isMenuOpened) {
                document.body.classList.remove('sidebar-enable');
            } else {
                document.body.classList.add('sidebar-enable');
            }
        }
    };

    return (
        <>
            <div id="wrapper">
                <Suspense fallback={loading()}>
                    <AdminTopbar openLeftMenuCallBack={openMenu} hideLogo={false} hideFilter={false} />
                </Suspense>
                {showLeftSideBar && <Suspense fallback={loading()}>
                    <AdminLeftSidebar />
                </Suspense>}
                <div className={`admin-content-page ${!showLeftSideBar ? 'mx-0 container-fluid mx-auto' : ''}`}>
                    <div className="content">
                        <Container fluid>
                            <Suspense fallback={loading()}>{children}</Suspense>
                        </Container>
                    </div>

                    <Suspense fallback={loading()}>
                        <Footer />
                    </Suspense>
                </div>
            </div>
        </>
    );
};
export default AdminLayout;
